import { selexpPerformanceApiDuck } from '../selexp-performance-api-duck';
import { TDataRefreshDetails } from './types-data-refresh-details';

type TGetDataRefreshDetailsArgs = {
  // Caching key used to re-fetch after impersonation changes.
  cacheKey?: string;
  customParams?: { [key: string]: string };
  noFilters?: boolean;
};

export const dataRefreshDetailsApiDuck = selexpPerformanceApiDuck.injectEndpoints({
  endpoints: (builder) => ({
    getDataRefreshDetails: builder.query<TDataRefreshDetails, TGetDataRefreshDetailsArgs | void>({
      query: (args) => ({
        url: '/v2/DataRefresh/GetDataRefreshDetails',
        customParams: args?.customParams,
        noFilters: args?.noFilters,
      }),
    }),
  }),
});

export const { useGetDataRefreshDetailsQuery } = dataRefreshDetailsApiDuck;
